import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import AuthContext from "../../Context/AuthContext";
import "./header.scss";

// Same user glyph geometry as the BottomNavigation profile tab so the
// account entry looks identical in both shell bars.
export function HeaderAccountIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
}

function getAccountInitial(user) {
  if (!user) {
    return "";
  }
  const source =
    user.firstName || user.first_name || user.name || user.displayName || user.phone || "";
  const initial = String(source).trim().charAt(0);
  return initial || "";
}

// Reusable account entry for the Header. Read-only: it never mutates auth
// state, it just links to the account page and reflects the signed-in user
// (initial avatar) plus the active state when already on that page.
// Reads AuthContext directly (instead of useAuth) so it also renders safely
// outside an AuthProvider (e.g. isolated tests) as a plain icon button.
function HeaderAccount({ to = "/UserPanel", label = "حساب کاربری" }) {
  const { user } = useContext(AuthContext) ?? {};
  const { pathname } = useLocation();
  const active = pathname === to || pathname.startsWith(`${to}/`);
  const initial = getAccountInitial(user);

  return (
    <Link
      to={to}
      className={`HeaderAccount${active ? " HeaderAccount--active" : ""}`}
      aria-label={label}
      title={label}
      aria-current={active ? "page" : undefined}
      data-testid="header-account"
      data-active={active ? "true" : "false"}
    >
      <span className="HeaderAccount-avatar" aria-hidden="true">
        {initial ? (
          <span className="HeaderAccount-initial">{initial}</span>
        ) : (
          <HeaderAccountIcon />
        )}
      </span>
    </Link>
  );
}

export default HeaderAccount;
